import { React, useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import "./PopularCategories.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
import Popular_Product_Card from "../../Common-Component/Popular_Product_Card/Popular_Product_Card";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";
import { popularCategory } from "../../../utils/apis/Product/Product";
import Common_Category_Swiper from "../../Common-Component/common_category_swiper/Common_Category_Swiper";
import Blue_Btn from "../../Common-Component/common_btn/blue_btn/Blue_Btn";

const PopularCategories = () => {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [showAll, setShowAll] = useState(false);

  const { IMG_URL, shimmerLoader, setShimmerLoader } = useContext(Context);
  const [popularCategories, setPopularCategories] = useState([]);
  const navigate = useNavigate();

  const handleMainSliderClick = (direction) => {
    if (swiperInstance) {
      if (direction === "prev") {
        swiperInstance.slidePrev();
      } else if (direction === "next") {
        swiperInstance.slideNext();
      }
    }
  };

  const handleNext = (id) => {
    navigate(`/select-from-category/${id}`);
  };

  const getPopularCategory = async () => {
    setShimmerLoader(true);
    const res = await popularCategory();
    if (res?.success) {
      setPopularCategories(res?.data);
      setShimmerLoader(false);
    }
  };

  useEffect(() => {
    getPopularCategory();
  }, []);

  const visibleCategories = showAll
    ? popularCategories
    : popularCategories.slice(0, 5);

  return (
    <>
      <section className="Popular-Categories">
        <div className="section_heading">
          <h2>Explore Categories</h2>
        </div>

        {visibleCategories?.map((cat) => (
          <div className="grocery_div" key={cat.id}>
            <Common_Category_Swiper
              data={cat?.sub_categories}
              theme_colour={cat?.background_colour}
              button_colour={cat?.button_colour}
              headingText={cat?.name}
              onItemClick={(subCat) =>
                navigate(
                  `/shop-subcategory?category_id=${cat.id}&category_image=${subCat.image}&sub_category_id=${subCat.id}&sub_category_name=${subCat.name}`,
                )
              }
            />
          </div>
        ))}

        <div className="text-center btn_holder">
          {popularCategories.length > 5 && !showAll && (
            <Blue_Btn
              btn_name="Show More Categories"
              onClick={() => setShowAll(true)}
            />
          )}

          {showAll && (
            <Blue_Btn btn_name="Show Less" onClick={() => setShowAll(false)} />
          )}
        </div>
      </section>
    </>
  );
};

export default PopularCategories;
